import React from 'react';

const Services = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-16 space-y-20">
      <section className="text-center">
        <h1 className="text-4xl font-bold text-teal-600 mb-6">
          Our Specialized Services
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          We provide dedicated operational teams that integrate seamlessly with your organization,
          delivering excellence across key business functions.
        </p>
      </section>

      {/* Detailed Services */}
      <div className="grid gap-16">
        {/* Graphics and Imaging */}
        <section className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6">Graphics and Imaging</h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">01</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Image Editing & Retouching</h3>
                  <p className="text-gray-600">Professional photo editing, color correction, and image enhancement services</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">02</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Graphic Design</h3>
                  <p className="text-gray-600">Creative design solutions for digital and print materials</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">03</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Visual Content Creation</h3>
                  <p className="text-gray-600">Custom illustrations, infographics, and visual assets</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4">Why Choose Our Graphics Team?</h3>
            <ul className="space-y-4 text-gray-600">
              <li>• Expert in industry-standard design tools</li>
              <li>• Quick turnaround times</li>
              <li>• Consistent quality and style</li>
              <li>• Scalable design support</li>
            </ul>
          </div>
        </section>

        {/* Print Media Operations */}
        <section className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6">Print Media Operations</h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">01</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Print Design & Layout</h3>
                  <p className="text-gray-600">Professional layout design for brochures, catalogs, and marketing materials</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">02</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Print Production</h3>
                  <p className="text-gray-600">End-to-end print production management and quality control</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">03</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Publication Support</h3>
                  <p className="text-gray-600">Magazine and newsletter design and production assistance</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4">Why Choose Our Print Team?</h3>
            <ul className="space-y-4 text-gray-600">
              <li>• Understanding of print requirements</li>
              <li>• Quality-focused approach</li>
              <li>• Cost-effective solutions</li>
              <li>• Timely delivery</li>
            </ul>
          </div>
        </section>

        {/* Digital Marketing Operations */}
        <section className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6">Digital Marketing Operations</h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">01</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Campaign Management</h3>
                  <p className="text-gray-600">End-to-end digital campaign planning, execution, and optimization</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">02</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Content Operations</h3>
                  <p className="text-gray-600">Content creation, management, and distribution across channels</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">03</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Social Media Management</h3>
                  <p className="text-gray-600">Comprehensive social media strategy and execution</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4">Why Choose Our Digital Team?</h3>
            <ul className="space-y-4 text-gray-600">
              <li>• Data-driven strategies</li>
              <li>• Cross-channel expertise</li>
              <li>• ROI-focused approach</li>
              <li>• Latest digital tools and techniques</li>
            </ul>
          </div>
        </section>

        {/* Business Analytics */}
        <section className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6">Business Analytics</h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">01</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Data Analysis</h3>
                  <p className="text-gray-600">Comprehensive data analysis and insights generation</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">02</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Performance Reporting</h3>
                  <p className="text-gray-600">Custom reporting and dashboard creation</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">03</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Business Intelligence</h3>
                  <p className="text-gray-600">Strategic insights and recommendations based on data analysis</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4">Why Choose Our Analytics Team?</h3>
            <ul className="space-y-4 text-gray-600">
              <li>• Advanced analytical skills</li>
              <li>• Business-focused insights</li>
              <li>• Custom reporting solutions</li>
              <li>• Data-driven decision support</li>
            </ul>
          </div>
        </section>

        {/* Finance Operations */}
        <section className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6">Finance Operations</h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">01</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Accounting Services</h3>
                  <p className="text-gray-600">Comprehensive accounting and bookkeeping support</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">02</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Financial Analysis</h3>
                  <p className="text-gray-600">Detailed financial reporting and analysis</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-teal-100 p-2 rounded-lg mr-4">
                  <span className="text-teal-600 font-semibold">03</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Accounts Management</h3>
                  <p className="text-gray-600">Accounts payable and receivable processing</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4">Why Choose Our Finance Team?</h3>
            <ul className="space-y-4 text-gray-600">
              <li>• Experienced professionals</li>
              <li>• Accurate and timely processing</li>
              <li>• Strong compliance focus</li>
              <li>• Scalable support model</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Services;
